class ComponentTaglineSwap extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.measure();

    if (document.fonts) {
      document.fonts.ready.then(() => this.measure());
    }

    this.addDirectEvent("resize", window, () => this.measure());
  }

  measure() {
    const [resting, hovered] = this.children;

    if (!resting || !hovered) {
      return;
    }

    this.style.setProperty("--tagline-width", this.naturalWidth(resting));
    this.style.setProperty("--tagline-width-hover", this.naturalWidth(hovered));
  }

  naturalWidth(element) {
    const clone = element.cloneNode(true);

    clone.style.position = "absolute";
    clone.style.visibility = "hidden";
    clone.style.width = "max-content";
    clone.style.opacity = "1";
    clone.style.transform = "none";

    this.appendChild(clone);

    const width = clone.getBoundingClientRect().width;

    clone.remove();

    return `${Math.ceil(width)}px`;
  }
}

customElements.define("component-tagline-swap", ComponentTaglineSwap);
